<template>
  <div v-if="!showNewUI" style="min-height: 100vh" class="d-flex flex-column">
    <Navigation
        @logout="showLogOutDialog = true"
        @onClickAppBarIcon="drawerOpen = !drawerOpen"
        v-if="!$vuetify.breakpoint.xs"
    />
    <MobileNavBar v-else/>
    <div class="add-top-margin mt-15 mx-xl-15 px-xl-15 px-5 px-md-8">
      <div v-if="loading">
        <v-skeleton-loader
            class="my-3"
            style="height: 30vh"
            type="card,list-item-avatar-two-line,article"
        />
        <v-row class="mt-5">
          <v-col class="" cols="12" lg="7" md="7">
            <v-skeleton-loader
                class="my-3"
                type="card,article, article, article"
            />
          </v-col>
          <v-col class="" cols="12" lg="5" md="5">
            <v-skeleton-loader
                class="my-3"
                type="card,article, article, article"
            />
          </v-col>
        </v-row>
      </div>
      <div v-if="!loading" class="mt-2">
        <div class="elevation-1 curved-divs" style="background-color: white">
          <div
              class="d-flex flex-column align-md-center align-lg-center justify-space-between"
              style="position: relative"
          >
            <Avatar
                :canRouteToProfile="false"
                :styles="avatarStyles"
                :user="mentor"
                class="mx-md-auto mx-lg-auto ml-4"
                size="180"
            />
          </div>

          <div class="d-flex flex-row pr-5 pt-15 mt-5">
            <v-spacer />
            <v-btn
                v-if="isAuthenticated && user.id !== mentor.id"
                :loading="followLoading"
                :outlined="mentor.profile.has_followed"
                class="elevation-0"
                color="primary"
                small
                @click="followMentor()"
            >
              {{ !mentor.profile.has_followed ? "Follow" : "UnFollow" }}
            </v-btn>
            <v-menu left min-width="200px" max-width="250px" offset-x rounded>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on"  color="primary" class="ml-2">mdi-dots-horizontal</v-icon>
              </template>
              <v-card class="pa-0">
                <v-list-item-content class="pa-0">
                  <div class="text-left d-flex flex-column pa-0">
                    <v-list-item>
                      <v-btn
                          class="d-flex justify-space-between"
                          v-clipboard:copy="profileUrl"
                          v-clipboard:success="onProfileUrlCopy"
                          v-clipboard:error="onProfileUrlError"
                          block
                          text
                      >
                        <div class="font-weight-light pr-1">
                          Copy Profile Link
                        </div>
                        <v-icon >mdi-content-copy</v-icon>
                      </v-btn>
                    </v-list-item>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </div>

          <div class="mt-10 mb-5 ml-sm-4 ml-xm-4">
            <div class="my-1 font-weight-bold text-h5 text-center">
              {{ getDisplayNameOrEmail(mentor) }}
              <v-icon v-if="isMentorApproved" class="px-0 py-0 mt-0" color="green" small>mdi-check-decagram</v-icon>
            </div>
            <div class="text--darken-1 text-center mb-1">{{ mentor.profile.biography }}</div>
            <div class="d-flex flex-row align-center">
              <div class="mx-auto d-flex flex-column flex-md-row flex-lg-row flex-xl-row align-center">
                <div class="text-no-wrap mr-3">
                  <div class="d-flex flex-row">
                    <div v-if="country">
                      <v-icon color="">mdi-map-marker</v-icon>
                      {{ country }}
                    </div>
                    <div class="text-no-wrap text-center ml-3" v-if="joinedAt">
                      <v-icon color="">mdi-calendar</v-icon>
                      Joined on {{ joinedAt }}
                    </div>
                  </div>
                </div>
                <div class="text-no-wrap">
                  <div class="d-flex flex-row justify-space-between">
                    <a
                        class="text-decoration-none mr-3"
                        :href="mentor.profile.instagram_link"
                        v-if="mentor.profile.instagram_link"
                    >
                      <v-icon color="primary">mdi-instagram</v-icon>
                    </a>
                    <a
                        class="text-decoration-none"
                        :href="mentor.profile.facebook_link"
                        v-if="mentor.profile.facebook_link"
                    >
                      <v-icon color="primary">mdi-facebook</v-icon>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-divider />

          <div class="d-flex flex-column align-center">
            <div class="mt-5 text-lg-body-2 font-weight-light text-center">
              Work
            </div>
            <div class="font-weight-medium text-center pb-5">Mentor</div>
            <v-btn
                v-show="!showMoreInfo"
                class="elevation-0 mb-2 hidden-sm-and-up"
                color="primary"
                outlined
                width="95%"
                @click="showMoreInfo = true"
            >
              More info about @{{ mentor.username }}
            </v-btn>
          </div>
        </div>

        <v-row class="mt-2 mt-md-5 mt-lg-5">
          <v-col
              class=""
              cols="12"
              lg="7"
              md="7"
              order="last"
              order-md="first"
              order-lg="first"
              order-xl="first"
          >
            <v-card
                class="mb-2"
                :max-width="$vuetify.breakpoint.smAndDown ? '100vw': '50vw'"
                v-if="latestBlog && latestBlog.id"
            >
              <v-list>
                <v-list-item class="font-weight-light">
                  <h3>Latest Blog</h3>
                </v-list-item>
              </v-list>
            </v-card>
            <div v-if="latestBlog && latestBlog.id">
              <BlogCard :blog="latestBlog" card-width="93%" show-border/>
            </div>
            <div v-else>
              <v-card :max-width="$vuetify.breakpoint.smAndDown ? '100vw': '50vw'">
                <v-card-text>
                  <v-img
                      class="mx-auto"
                      :width="140"
                      :src="noBlogs"
                  />
                  <h3 class="text-center mt-1">Mentor has not published any blogs yet</h3>
                </v-card-text>
              </v-card>
            </div>

            <v-card
                class="my-4"
                v-show="comments.length"
                :max-width="$vuetify.breakpoint.smAndDown ? '100vw': '50vw'"
            >
              <v-list>
                <v-list-item class="comments font-weight-bold">
                  <h3> Recent Comments</h3>
                </v-list-item>
                <v-list-item
                    :to="`/blogs/${comment.post.slug}`"
                    class="comments" v-for="comment in comments.slice(0, 4)"
                    :key="comment.id"
                >
                  <div class="d-flex flex-column my-1">
                    <div
                        class="black--text text-truncate font-weight-bold text-wrap"
                        :style="{width: $vuetify.breakpoint.xs ? '80vw' : '36vw'}"
                        v-html="comment.post.title === '...' ? '' : comment.post.title"
                    />
                    <div
                        v-html="comment.body === '...' ? '' : comment.body"
                        class="body font-weight-light black--text text-truncate text-wrap"
                        :style="{width: $vuetify.breakpoint.xs ? '80vw' : '36vw'}"

                    />
                  </div>
                </v-list-item>
                <v-list-item v-show="false">
                  <a class="text-decoration-none" href="#">
                    View last 250 comments
                  </a>
                </v-list-item>
              </v-list>
            </v-card>

            <v-card
                class="mb-1"
                :max-width="$vuetify.breakpoint.smAndDown ? '100vw': '50vw'"
                v-if="blogs.length"
            >
              <v-list>
                <v-list-item class="font-weight-light">
                  <h3> Mentors Blogs</h3>
                </v-list-item>
              </v-list>
            </v-card>

            <div v-if="blogs.length">
              <BlogCard
                  v-for="blog in blogs"
                  :key="blog.slug" :blog="blog"
                  card-width="93%"
                  show-border
              />
            </div>
          </v-col>
          <v-col
              v-show="
            showMoreInfo ||
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.xl
          "
              class="mt-3"
              cols="12"
              lg="5"
              md="5"
          >
            <v-row>
              <v-col cols="12" v-show="false">
                <div
                    class="elevation-1 curved-divs"
                    style="background-color: white"
                >
                  <v-row>
                    <v-col cols="12" >
                      <div class="ml-4 font-weight-bold">Badges</div>
                      <v-divider />
                      <div class="ml-4 my-2">
                        <v-row>
                          <v-col
                              v-for="item in [1, 2, 3, 4]"
                              :key="item"
                              cols="6"
                          >
                            <v-img
                                :alt="'alt' + item"
                                class="mx-auto"
                                src="https://res.cloudinary.com/practicaldev/image/fetch/s--ajGtUgSU--/c_limit,f_auto,fl_progressive,q_80,w_180/https://dev-to-uploads.s3.amazonaws.com/uploads/badge/badge_image/80/hacktoberfest2020-badge_2.png"
                                style="width: 130px; height: 120px;"
                            />
                          </v-col>
                        </v-row>
                        <div class="text-center mt-4">
                          <a class="text-decoration-none" href="#"
                          >Show all 7 badges</a
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col class="my-lg-3 my-md-3" cols="12" v-show="false">
                <div
                    class="elevation-1 curved-divs"
                    style="background-color: white"
                >
                  <v-row>
                    <v-col cols="12">
                      <div class="ml-4 font-weight-bold">Currently learning</div>
                      <v-divider />
                      <div class="ml-4 my-2">Master's Degree in IT</div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="12" v-show="false">
                <div
                    class="elevation-1 curved-divs"
                    style="background-color: white"
                >
                  <v-row>
                    <v-col cols="12">
                      <div class="ml-4 font-weight-bold">Other Skills</div>
                      <v-divider />
                      <div class="ml-4 my-2">Ruby, Python, C#</div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col class="my-lg-3 my-md-3" cols="12" v-show="false">
                <div
                    class="elevation-1 curved-divs"
                    style="background-color: white"
                >
                  <v-row>
                    <v-col cols="12">
                      <div class="ml-4 font-weight-bold">
                        Currently hacking on
                      </div>
                      <v-divider />
                      <div class="ml-4 my-2">
                        <a class="text-decoration-none" href="#"
                        >https://github.com/Defman21</a
                        >
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="12">
                <div
                    class="elevation-1 curved-divs"
                    style="background-color: white"
                >
                  <v-row class="ml-1">
                    <v-col cols="12 d-flex justify-left align-center">
                      <v-icon class="mr-2">mdi-book-open-variant</v-icon>
                      {{kFormatter(mentor.profile.number_of_posts)}} posts published
                    </v-col>
                    <v-col cols="12 d-flex justify-left align-center">
                      <v-icon class="mr-2">mdi-chat-outline</v-icon>
                      {{kFormatter(mentor.profile.number_of_comments)}} comments written
                    </v-col>
                    <v-col cols="12 d-flex justify-left align-center">
                      <v-icon class="mr-2">mdi-tag-multiple</v-icon>
                      {{kFormatter(mentor.profile.number_of_tags)}} tags followed
                    </v-col>
                    <v-col cols="12 d-flex justify-left align-center">
                      <v-icon class="mr-2">mdi-account-group</v-icon>
                      {{kFormatter(mentor.profile.number_of_followers)}} followers
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mt-auto">
      <Footer />
    </div>
  </div>
  <div v-else>
    <DesktopMentorProfile
        v-if="!$vuetify.breakpoint.xs"
        :mentor="mentor"
        :user="user"
        :blogs="blogs"
        :loading="loading"
        :isAuthenticated="isAuthenticated"
        :profileUrl="profileUrl"
        :joinedAt="joinedAt"
        :noBlogsImage="noBlogs"
        :followingLoading="followLoading"
        :showLogOutDialog="showLogOutDialog"
        :numberOfPosts="kFormatter(mentor.profile.number_of_posts)"
        :numberOfComments="kFormatter(mentor.profile.number_of_comments)"
        :numberOfTags="kFormatter(mentor.profile.number_of_tags)"
        :numberOfFollowers="kFormatter(mentor.profile.number_of_followers)"
        :displayNameOrEmail="getDisplayNameOrEmail(mentor)"
        @profileUrlCopySuccess="onProfileUrlCopy"
        @profileUrlCopyError="onProfileUrlError"
        @followMentor="followMentor"
        @fetchMoreBlogs="fetchMoreBlogs"
        @handleLogout="handleLogout"
    />
    <MobileMentorProfile
        v-if="$vuetify.breakpoint.xs"
        :mentor="mentor"
        :user="user"
        :blogs="blogs"
        :loading="loading"
        :isAuthenticated="isAuthenticated"
        :profileUrl="profileUrl"
        :joinedAt="joinedAt"
        :noBlogsImage="noBlogs"
        :followingLoading="followLoading"
        :showLogOutDialog="showLogOutDialog"
        :numberOfPosts="kFormatter(mentor.profile.number_of_posts)"
        :numberOfComments="kFormatter(mentor.profile.number_of_comments)"
        :numberOfTags="kFormatter(mentor.profile.number_of_tags)"
        :numberOfFollowers="kFormatter(mentor.profile.number_of_followers)"
        :displayNameOrEmail="getDisplayNameOrEmail(mentor)"
        @profileUrlCopySuccess="onProfileUrlCopy"
        @profileUrlCopyError="onProfileUrlError"
        @followMentor="followMentor"
        @fetchMoreBlogs="fetchMoreBlogs"
        @handleLogout="handleLogout"
    />
  </div>
</template>

<script>
import BlogCard from "@/components/BlogCard";
import Avatar from "@/components/Avatar";
import { getDisplayNameOrEmail } from "@/utilz/dispalyNameOrEmail";
import countries from "@/constants/countries.json";
import { mapGetters } from "vuex";
import {kFormatter} from "@/utilz/kFormatter";
import HasAccountTypeAndUSerExistsMixin from "@/mixins/HasAccountTypeAndUSerExistsMixin";
import emptyPage from "@/assets/no_data.svg";
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import MobileNavBar from "@/components/MobileNavBar";
import infiniteScroll from "@/mixins/InfiniteScroll";
import DesktopMentorProfile from "@/views/profile/mentor/DesktopMentorProfile";
import MobileMentorProfile from "@/views/profile/mentor/MobileMentorProfile";

export default {
  mixins: [HasAccountTypeAndUSerExistsMixin, infiniteScroll],
  components: {
    MobileMentorProfile,
    DesktopMentorProfile,
    MobileNavBar,
    BlogCard,
    Avatar,
    Navigation,
    Footer
  },
  metaInfo() {
    return {
      title: this.fullName,
      url: window.location.href,
      meta: [
        { name: "title", content: this.fullName },
        {
          name: "description",
          content: "Welcome to my bio",
        },
        //Facebook
        { name: "og:type", content: "Website" },
        { name: "og:title", content: this.fullName },
        { name: "og:description", content: this.mentor.profile.biography || "Welcome to my guio profile page" },
        { name: "og:image", content: this.mentor.profile.avatar || this.Logo },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: window.location.href },
        {
          name: "twitter:title",
          content: this.fullName,
        },
        { name: "twitter:description", content: this.mentor.profile.biography || "welcome to my guio profile page" },
        {
          name: "twitter:image",
          content: this.mentor.profile.avatar || this.Logo,
        },
      ],
    };
  },
  data() {
    return {
      showLogOutDialog: false,
      item: 1,
      noBlogs: emptyPage,
      countries,
      profileUrl: window.location.href,
      loading: false,
      followLoading: false,
      avatarStyles: {
        position: "absolute",
        top: "-3em",
        border: ".5em solid #f5f6f8 !important",
      },
      showMoreInfo: false,
      uuid: "",
      mentor: {
        id: "",
        email: "",
        username: "",
        profile: {
          avatar: "",
          country: "",
          first_name: "",
          last_name: "",
          number_of_followers: 0,
          number_of_tags: 0,
          number_of_comments: 0,
          number_of_posts: 0,
          has_followed: 0,
        },
        uuid: "",
        account_types: [],
      },
      comments: [{
        id: "",
        body: "",
        post: {
          slug: "",
          title: ""
        }
      }],
      blogs: [],
      latestBlog: {},
      fetchUrl: ""
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    showNewUI() {
      return true
    },
    miniVariant() {
      return this.drawerOpen && !this.$vuetify.breakpoint.xs;
    },
    isMentorApproved() {
      return this.mentor.profle?.status?.toUpperCase() === "APPROVED";
    },
    country() {
      return this.countries.find(
        ({ code }) =>
          code.toLowerCase() === this.mentor?.profile?.country?.toLowerCase()
      )?.name;
    },
    joinedAt() {
      return this.$moment(new Date(this.mentor.profile.created)).format(
        "MMM, DD YYYY"
      );
    },
    fullName() {
      return (this.mentor?.profile?.first_name && this.mentor?.profile?.first_name) ? `${this.mentor?.profile?.first_name} ${this.mentor?.profile?.last_name}` : this.mentor.username;
    },
  },
  async mounted() {
    await this.fetchMentorsProfile();
    await this.fetchMentorsComments();
    await this.fetchMentorsBlogs();
    this.$analytics.logEvent("view_mentor", {
      user: this.user,
      time: new Date(),
      url: window.location.href,
      version: "frontend version"
    });
  },
  methods: {
    kFormatter(value) {
      return kFormatter(value)
    },
    getDisplayNameOrEmail(user) {
      return getDisplayNameOrEmail(user);
    },
    async fetchMentorsProfile() {
      this.uuid = this.$router.history.current.params.uuid;
      try {
        this.loading = true;
        const response = await this.axios.get(
          `users/mentor_profile/?uuid=${this.uuid}`
        );
        this.mentor = { ...response.data.user };
        this.fetchUrl =  `blogs/posts/?author=${this.mentor.email}&&limit=${this.limit}`
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if(error.response?.status === 404) {
          this.$router.push('/:catchAll(.*)').then()
        } else {
          this.$snackbar.showMessage({
            content: this.$t("errors.somethingWentWrongError"),
            color: "error",
          });
        }
      }
    },
    async fetchMentorsBlogs() {
      try {
        this.loading = true;
        const response = await this.axios.get(this.fetchUrl);
        this.blogs = [...new Set(response.data.results)];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    fetchMoreBlogs($state) {
      this.infiniteHandler($state,'', false, 'blogs')
    },
    async fetchMentorsComments() {
      try {
        this.loading = true;
        const response = await this.axios.get(
          `blogs/comments/user/?uuid=${this.uuid}`
        );
        this.comments = response.data.results.filter(comment => !!comment.post);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async followMentor() {
      try {
        this.followLoading = true;
        await this.axios.post(`users/following/?uuid=${this.mentor.uuid}`, {
          token: localStorage.getItem("access_token"),
        });
        const { profile } = this.mentor;
        this.mentor = {
          ...this.mentor,
          profile: { ...profile, has_followed: !profile.has_followed },
        };
        this.followLoading = false;
      } catch (error) {
        this.followLoading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    onProfileUrlCopy() {
      this.$snackbar.showMessage({
        content: "Profile link copied",
        color: "success",
      });
    },
    onProfileUrlError() {
      this.$snackbar.showMessage({
        content: "Profile link not copied",
        color: "warning",
      });
    },
    handleLogout() {
      this.showLogOutDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.v-btn {
  text-transform: none !important;
}

.comments {
  border-bottom: 0.1em solid #f5f6f8;
}

.curved-divs {
  border-radius: 0.3em;
}
.add-top-margin {
  margin-top: 8em !important;
}

.body {
  overflow-x: auto;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .curved-divs {
    border-radius: 0;
  }
  .add-top-margin {
    margin-top: 20vh !important;
  }
}
</style>
